import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LILAC_400, TRANSPARENT, Typography } from '@airtel/air-design-system';
import { Fragment, useState } from 'react';
import { Image, View } from 'react-native';
import { getImageContainerStyles } from './ImageContainerStyles';
var ImageContainer = _ref => {
  var arrImages = _ref.arrImages,
    isLargeScreen = _ref.isLargeScreen,
    type = _ref.type,
    imageStyle = _ref.imageStyle;
  var isMobileScreen = !isLargeScreen;
  var imageContainerStyles = getImageContainerStyles(isMobileScreen, type);
  var _useState = useState(TRANSPARENT),
    placeholderBgColor = _useState[0],
    setPlaceholderBgColor = _useState[1];
  var hiddenBenefitsCount = 0;
  var updatedBenefits = [...arrImages];
  var updatedBenefitsLength = 3;
  if ((arrImages === null || arrImages === void 0 ? void 0 : arrImages.length) > 3) {
    updatedBenefits.length = updatedBenefitsLength;
    hiddenBenefitsCount = (arrImages === null || arrImages === void 0 ? void 0 : arrImages.length) - (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length);
  }
  var benefitsImagesDimensions = isMobileScreen ? {
    width: 28,
    height: 28
  } : {
    width: 32,
    height: 32
  };
  return _jsxs(View, Object.assign({
    style: imageContainerStyles.benefitsContainer
  }, {
    children: [(updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length) > 0 && (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.map((benefit, index) => {
      return _jsx(Fragment, {
        children: !!benefit && _jsx(Image, {
          source: {
            uri: benefit,
            width: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.width,
            height: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.height
          },
          style: [imageContainerStyles.benefitImage, {
            backgroundColor: placeholderBgColor
          }, imageStyle],
          onError: () => setPlaceholderBgColor(LILAC_400)
        })
      }, "benefit-" + index);
    })), hiddenBenefitsCount > 0 && _jsx(View, Object.assign({
      testID: "hidden-benefit",
      style: imageContainerStyles.hiddenBenefitsCountContainer
    }, {
      children: _jsx(Typography, {
        text: "+" + hiddenBenefitsCount,
        type: "body-single-line-xs"
      })
    }))]
  }));
};
export default ImageContainer;